<mat-form-field class="form-element" appearance="fill">
  <mat-label>material</mat-label>
  <mat-select (selectionChange)="materialChangeAction($event)" [formControl]="selectListControl">
    <mat-option value="empty"></mat-option>
    @for (material of materialList; track material) {
      <mat-option [value]="material.name">{{ material.name }}</mat-option>
    }
    <mat-option value="create">Add new material</mat-option>
  </mat-select>
</mat-form-field>